import React, { createContext, useContext, useState } from 'react';

const UnsavedContext = createContext();

export const UnsavedProvider = ({ children }) => {
  const [hasUnsaved, setHasUnsaved] = useState(false);

  return (
    <UnsavedContext.Provider value={{ hasUnsaved, setHasUnsaved }}>
      {children}
    </UnsavedContext.Provider>
  );
};

export const useUnsaved = () => useContext(UnsavedContext);
